<template>
  <div>
    <h6 v-if="!hasRightsForSelect">
      {{ selectedRoles }}
    </h6>
    <dropdown v-else class="form-control">
      <template #buttonText>
        {{ selectedRoles }}
      </template>
      <template #dropdownContent>
        <div class="p-3">
          <div v-for="(role, key) in rolesList" :key="key" class="custom-control" :class="`custom-${type}`">
            <input
              :type="type"
              class="custom-control-input"
              :class="{ 'input-danger': isInvalid }"
              :id="key"
              :value="role"
              v-model="localRoles"
              :disabled="isDisabled(role)"
            />
            <label :for="key" class="custom-control-label">
              {{ getRoleTitle(role) }}
            </label>
          </div>
        </div>
      </template>
    </dropdown>
  </div>
</template>

<script>
import { roles } from '@/main.config.js'
import { userRights } from '@/mixins/user-rights.js'
import { getRoleTitle } from '@/mixins/get-role-title.js'

export default {
  name: 'UserRolesSelect',
  mixins: [userRights, getRoleTitle],
  components: {
    Dropdown: () => import('@/base/BaseDropdown.vue')
  },
  model: {
    prop: 'userRoles'
  },
  props: {
    userRoles: {
      type: [Array, String],
      required: true
    },
    forFilter: {
      type: Boolean,
      default: false
    },
    isInvalid: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: () => ({
    localRoles: []
  }),
  mounted() {
    this.localRoles = this.userRoles
  },
  watch: {
    localRoles: {
      handler() {
        this.$emit('input', this.localRoles)
      }
    },
    isReadonlyChecked() {
      if (!this.forFilter && this.isReadonlyChecked) {
        this.localRoles = [roles.readonly]
      }
    }
  },
  computed: {
    type() {
      return this.forFilter ? 'radio' : 'checkbox'
    },
    rolesList() {
      let list = {}
      if (this.forFilter) {
        list['all'] = ''
      }
      if (this.isNeuroAdmin) {
        list['hospital'] = 'hospital_admin'
      } else {
        // eslint-disable-next-line no-unused-vars
        for (let key in roles) {
          if (this.ifRoleCanBeInList(roles[key])) {
            list[key] = roles[key]
          }
        }
      }

      return list
    },
    selectedRoles() {
      if (this.localRoles && this.localRoles.length === 0) {
        return this.forFilter ? this.$t('role.all') : this.$t('role.notChosen')
      }
      if (typeof this.localRoles === 'string') {
        return this.getRoleTitle(this.localRoles)
      }
      return this.getRolesTitlesList(this.localRoles)
    },
    isReadonlyChecked() {
      return this.localRoles.indexOf(roles.readonly) !== -1
    },
    hasRightsForSelect() {
      return this.forFilter || this.isAnyAdmin
    },
    addRole() {
      return this.$route.meta.addRole
    }
  },
  methods: {
    ifRoleCanBeInList(role) {
      if (role === roles.neuro) {
        return false
      }
      if (this.forFilter) {
        return true
      }
      if (this.addRole) {
        return role !== roles.readonly
      }
      return !(!this.isAnyAdmin && role === roles.readonly)
    },
    isDisabled(role) {
      if (this.forFilter || !this.isReadonlyChecked) {
        return false
      }
      if (role === roles.readonly) {
        return false
      }
      return true
    }
  }
}
</script>
